import React from 'react';
import Layout from '../layout';
import AvdSectionOne from '../components/Esper/Avd/AvdSectionOne';
import AvdSectionTwo from '../components/Esper/Avd/AvdSectionTwo';
import AvdHero from '../assets/v2/png/AvdHero.png';
import AvdSectionThree from '../components/Esper/Avd/AvdSectionThree';
import messages from '../i18n/en';

export default (props: any) => (
  <Layout
    ogImage={AvdHero}
    messages={messages}
    title={'Build Custom Android Virtual Devices'}
    location={props.location}
    description={`Test applications for Android kiosk mode and enterprise devices using Esper's Android Virtual Device Emulator, an AVD solution for application development. `}
    keywords={`"android emulator,android avd,avd,Android virtual device,Test Apps"`}
  >
    <AvdSectionOne />
    <AvdSectionTwo />
    <AvdSectionThree />
  </Layout>
);
